import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMasksTheater, faMusic } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const HomeIntroSection = () => {
  const { t } = useTranslation();

  return (
    <section className="w-full flex justify-center px-4 py-1 mt-4">
      <div className="w-full max-w-4xl text-center">
        <h1 className="text-3xl font-bold underline underline-offset-8 mb-8 decoration-brand-red-text">
          {t("homeIntro.heading")}
        </h1>

        <p
          className="text-gray-200 text-base leading-relaxed mb-4"
          dangerouslySetInnerHTML={{ __html: t("homeIntro.p1") }}
        />

        <p
          className="text-gray-200 text-base leading-relaxed mb-4"
          dangerouslySetInnerHTML={{ __html: t("homeIntro.p2") }}
        />

        <p className="text-gray-200 text-base leading-relaxed mb-4">
          <FontAwesomeIcon icon={faMasksTheater} className="text-brand-red-text mr-2" />
          {t("homeIntro.p3")}
        </p>

        <p className="text-gray-200 text-base leading-relaxed mb-4">
          <FontAwesomeIcon icon={faMusic} className="text-brand-red-text mr-2" />
          {t("homeIntro.p4")}
        </p>

        <p
          className="text-gray-200 text-base leading-relaxed mb-8"
          dangerouslySetInnerHTML={{ __html: t("homeIntro.p5") }}
        />

        {/* Mark Section */}
        <div className="mt-12">
          <h3 className="text-3xl font-extrabold underline underline-offset-8 decoration-brand-red-text mb-8 text-center">
            {t("homeIntro.brands")}
          </h3>
          <div className="flex justify-center items-center space-x-24">
            {/* Theater Logo */}
            <div className="text-center w-48 h-48 flex items-center justify-center">
              <img
                src="/theater.png"
                alt="Tiyatro"
                className="w-48 h-48 object-contain"
              />
            </div>

            {/* Piano Logo */}
            <div className="text-center w-56 h-64 flex items-center justify-center">
              <img
                src="/piano.png"
                alt="Piyano"
                className="w-56 h-64 object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeIntroSection;